module.exports = __webpack_public_path__ + "img/medium-white.3ae08207.png";